





















































































































































































































































































import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import FlightPolicyService from "@/service/flightPolicyService";
import { ProductEntity, SearchModel } from "@/model/FlightPolicy";
import productList from "../modules/productList.vue";
import { ServiceType, VoyageType, LowestRule } from "@/model/Base";
import { ProductInfoSearchModel, ProductInfo } from "@/model/Policy";
import { DurationTime, daysDiff, isOfw } from "@/utils/utils";
import dataShare from "../dataShare";
import * as _ from "lodash";
import { Overlay, Loading, Popup, Empty, NoticeBar } from "vant";
import moment from "moment";
import LoadingFrame from "@/components/loadingFrame.vue";
import { removeKeepalive } from "@/views/modules/keepUtils";
import RetainTickets from "./modules/RetainTickets.vue";
import { TradeDetailEntity } from "@/model/Bill";
import billService from "@/service/billService";
import { EventBus } from "@/utils/eventBus";
@Component({
  name: "flightList",
  components: {
    "product-list": productList,
    [Overlay.name]: Overlay,
    [Loading.name]: Loading,
    [Popup.name]: Popup,
    [Empty.name]: Empty,
    [NoticeBar.name]: NoticeBar,
    ["retain-tickets"]: RetainTickets,
  },
  filters: {
    DurationTime,
  },
  methods: {
    daysDiff,
  },
})
export default class extends Vue {
  //data
  dataShare = dataShare;
  flightLists: ProductEntity[] = [];
  oldFlightLists: ProductEntity[] = [];
  RetainTickets: TradeDetailEntity[] = [];
  get isOfwApp() {
    return isOfw();
  }
  data = {
    LevelBerth: "",
    TicketPrice: 0,
    // DepartDate: (this as any).$moment().format("YYYY-MM-DD"),
    RuleID: "",
    CompanyID: "S00008447831",
    ApplyArea: 1126,
    PageCount: "",
    PageSize: 50,
    PageNo: 1,
    RecordCount: 0,
    AdultCount: 1,
    ChildCount: 0,
    InfantCount: 0,
    KeyWords: "",
    LevelId: "",
    Wheres: [
      {
        SelectCityID: "SHABJS" + (this as any).$moment().format("YYYY-MM-DD"),
        ConsumerZoneCode: "SHA",
        FinishedZoneCode: "BJS",
        ConsumerDate: (this as any).$moment().format("YYYY-MM-DD"),
      },
    ],
    Filters: {
      DepartAirport: "",
      ArrivalAirport: "",
      BtripRules: "",
      Transit: "",
      AirwayCode: "",
      DepartTime: "",
      ArrivalTime: "",
      AirportDepartTime: "asc",
      AirportArrivalTime: "",
      Price: "",
      Duration: "",
      ShareAirwayCode: "",
      FlightCode: "",
      FlightNo: "",
      BerthCode: "",
      PackagePrice: "",
    },
    VoyageType: 1161,
    BookingType: 1529,
    Consumers: [""],
    UniqueID: undefined,
    ProductID: "",
    GoodsId: "",
  };
  ShoppingID = "";
  isShowSkeleton = true;
  departTime = "";
  isLoading = false;
  MustConform = "";
  FeatureCodes = "";
  isEmptyState = false;
  showRequirement = false;

  get DepartTime(): string {
    return (this as any).$route.query.DepartDate;
  }

  // 判断是否为国际往返程去程

  isInternationalRoundTripDeparture = false;
  //mounted
  mounted() {
    // 监听滚动事件
    EventBus.$on("page-scroll", this.wacthScroll);
    this.departTime = this.DepartTime;
    if (!this.$route.query.Selected) {
      //返程
      this.dataShare.localContrarys = [];
    }

    let query = this.$route.query;

    this.isInternationalRoundTripDeparture = String(query.ApplyArea) === "1127" && String(query.VoyageType) === "1162" && !query.Selected;

    let filters = this.data.Filters;
    if (query.AirwayCode != undefined) {
      filters.AirwayCode = query.AirwayCode as string;
    }
    if (query.DepartCode) {
      filters.DepartAirport = query.DepartCode as string;
    }
    if (query.ArriveCode) {
      filters.ArrivalAirport = query.ArriveCode as string;
    }

    //获取航班列表
    this.getListData();
    this.loadRetainTickets();
  }
  beforeDestroy() {
    // 记得在组件销毁前移除事件监听
    EventBus.$off("page-scroll", this.wacthScroll);
  }
  // 监听滚动事件
  wacthScroll({ scrollTop, scrollHeight, clientHeight, isBottom }: { scrollTop: number; scrollHeight: number; clientHeight: number; isBottom: boolean }) {
    // 航程数量 和 单一航程dom高度
    const flightNum = this.flightLists.length;
    const flight = this.$refs.flightListRef as HTMLElement[];
    const flightHeight = flight[0].clientHeight;
    // 推荐航程数量 和 推荐单一航程dom高度
    const productNum = this.LowestPrices.length;
    const product = this.$refs.productListRef as HTMLElement[];
    const productHeight = product[0].clientHeight;
    // TOOD 推荐航程全部卷入且所有航程卷入一半后 开启需求单推荐侧边按钮
    const showHeight = productNum * productHeight + Math.ceil(flightNum / 3) * flightHeight;
    if (scrollTop >= showHeight) {
      this.showRequirement = true;
    } else {
      this.showRequirement = false;
    }
  }
  loadRetainTickets() {
    let __self = this;
    let query = this.$route.query;
    let consumers: any[] = JSON.parse(query.Consumers as string);
    let data = {
      Consumers: consumers.map(o => {
        return { UserID: o.ConsumerID };
      }),
      ConsumerCityCode: query.DepartCity as string,
      FinishedCityCode: query.ArriveCity as string,
    };
    billService.getUserTicketStatus(data).then(json => {
      if (json.result && json.isSucc) {
        __self.RetainTickets = json.result;
      }
    });
  }
  activated() {
    // this.valiad = true;
    this.dialogVisible = false;
  }
  Transit:number[] = []
  filterTransit(Transit:number[]){
    const __self = this;
    // 如果有值 列表查询完成后执行  
    if(Transit){
       const selectedTransit = new Set(Transit);
       // 根据筛选条件过滤航班列表
       __self.flightLists = __self.oldFlightLists.filter(item => {
         const isDirectFlight = item.Products?.length === 1; // 直飞
         const isTransferFlight = item.Products && item.Products?.length > 1; // 中转

         // 根据选择的筛选条件返回对应航班
         if (selectedTransit.has(0) && selectedTransit.has(1)) {
           // 同时选择直飞和中转，显示所有航班
           return true;
         } else if (selectedTransit.has(0)) {
           // 只选择直飞
           return isDirectFlight;
         } else if (selectedTransit.has(1)) {
           // 只选择中转
           return isTransferFlight;
         }
         return true;
       });
    }
  }
  //methods
  getListData() {
    let query: {
      DepartDate: "";
      ArriveDate: undefined;
      DepartCity: "SHA";
      ArriveCity: "BJS";
      DepartCityName: "";
      ArriveCityName: "";
      ApplyArea: 1126;
      BookingType: 1529;
      VoyageType: 1161;
      BerthLevel: "";
      ServiceType: "FlightService";
      AdultCount: 1;
      ChildCount: 0;
      InfantCount: 0;
      FeatureCodes: "";
      ShoppingID: "";
      Consumers: "";
      UniqueID: undefined;
      Product: "";
      AirwayCode: "";
      SelectId: "";
      GoFlightCode: "";
      GoFlightNo: "";
      GoBerthCode: "";
      GoPackagePrice: "";
      GoFlightDate: "";
      GoGoodsId: "";
    } = this.$route.query as any;
    let data = this.data;
    _.forEach(query.Product, (item: any) => {
      if (item.FinishedCityName == query.ArriveCityName) {
        data.ProductID = item.ProductID;
      }
    });
    data.VoyageType = query.VoyageType;
    data.BookingType = query.BookingType;
    data.ApplyArea = query.ApplyArea;
    data.UniqueID = query.UniqueID;
    data.LevelId = query.BerthLevel;
    let searchData = data as any;
    searchData.ShoppingID = query.ShoppingID as string;
    searchData.SelectId = [query.SelectId];

    let where: any = {
      SelectCityID: "",
      ConsumerZoneCode: query.DepartCity,
      FinishedZoneCode: query.ArriveCity,
      ConsumerDate: this.departTime,
    };
    data.Wheres = [where];
    if (query.ArriveDate && query.VoyageType == VoyageType.RoundVoyage) {
      where.FinishedDate = query.ArriveDate;
    }
    data.Filters.FlightCode = query.GoFlightCode;
    data.Filters.FlightNo = query.GoFlightNo;
    data.Filters.BerthCode = query.GoBerthCode;
    data.Filters.PackagePrice = query.GoPackagePrice;
    if (query.UniqueID && query.AirwayCode) {
      data.Filters.AirwayCode = query.AirwayCode;
    }
    if (query.GoFlightDate) {
      where.FinishedDate = query.GoFlightDate;
    }
    data.GoodsId = query.GoGoodsId;
    let consumers: any[] = JSON.parse(query.Consumers);
    data.Consumers = consumers.map(o => o.ConsumerID);
    data.Wheres.forEach(o => (o.SelectCityID = `${o.ConsumerZoneCode}${o.FinishedZoneCode}${o.ConsumerDate}`));
    FlightPolicyService.getProductList(data as any).then((res: any) => {
      if (res.isSucc && res.result) {
        this.isShowSkeleton = false;
        this.isLoading = false;
        const query = this.$route.query;
        // 国际往返程-返程航班价格处理
        // if (String(query.VoyageType) === "1162" && String(query.ApplyArea) === "1127" && query.Selected) {
        //   res.result.entities.forEach((o: any) => {
        //     // 是否包含flight.MultiFlights
        //     const isMultiFlights = _.some(o.Extras, (item: any) => item.ExtraCode.trim() === "flight.MultiFlights");
        //     if (!isMultiFlights) {
        //       // 从路由参数中获取去程航班价格并添加到返程航班价格上
        //       const basisPrice = parseFloat(this.$route.query.BasisPrice as string) || 0;
        //       o.Goods.forEach((good: any) => {
        //         good.BasisPrice += basisPrice;
        //       });
        //     }
        //   });
        // }

        this.flightLists = res.result.entities!;
        this.oldFlightLists = res.result.entities!;
        this.ShoppingID = res.result.ShoppingID!;
        this.dataShare.AirwayList = res.result.filters.AirwayList;
        this.dataShare.ArriveAirportList = res.result.filters.ArriveAirportList;
        this.dataShare.DepartAirportList = res.result.filters.DepartAirportList;
        this.isEmptyState = false;
        if (!query.ShoppingID) {
          let query = this.$route.query;
          let path = this.$route.path;
          let newQuery = JSON.parse(JSON.stringify(query));
          newQuery.ShoppingID = res.result.ShoppingID;

          removeKeepalive(this.$route.fullPath);
          this.$router.replace({ path, query: newQuery });
        }
        // 再次执行中转/直飞筛选
        this.filterTransit(this.Transit);
        // 清空子组件的查询条件
        (this.$refs.productList as any).cleanFilter();
      } else {
        this.isShowSkeleton = false;
        this.isLoading = false;
        this.flightLists = [];
        this.oldFlightLists = [];
        this.isEmptyState = true;
        this.$root.$toast.fail(res.message);
      }
    });
  }

  get TripLimit() {
    let TripRuleData: any = this.TripRuleData;
    return (TripRuleData && TripRuleData.Limits && TripRuleData.Limits.length > 0 && TripRuleData.Limits[0]) || null;
  }
  lowPriceFlight: any = null;
  lowruletime(ent: any, berth: any) {
    // session.set("BenchmarkPrice", null);
    let __self = this;
    let lowerflight = [];
    let tripLimit: any = this.TripLimit;
    //判断差旅规则是否为相对最低价
    if (!tripLimit || tripLimit.Benchmark != LowestRule.ControLowestPrice) {
      return;
    }
    var adv = tripLimit.TimeSpace;
    var lowNum = tripLimit.BenchmarkCount || 1;
    var stTime = moment(ent.ConsumerDate)
      .add("hour", -adv)
      .unix();
    // .format("HH:mm");
    var endTime = moment(ent.ConsumerDate)
      .add("hour", adv)
      .unix();
    // .format("HH:mm");
    var lowent = null;
    //拿到时段低价航班的集合
    for (var a = 0; a < __self.flightLists.length; a++) {
      var flight: any = __self.flightLists[a];
      if (_.find(flight.Extras, p => p.ExtraCode == "flight.StopProduceName")) {
        continue;
      }
      var time = moment(flight.ConsumerDate).unix(); //.format("HH:mm");
      if (stTime <= time && time <= endTime) {
        // 满足时间条件的航班
        lowerflight.push(flight);
      }
    }
    // 获取区间管控的低价
    lowent = _.minBy(lowerflight, p => p.Goods[0].BasisPrice);
    // 按低到高排序
    let sortedFlightList = lowerflight.sort((a, b) => a.Goods[0].BasisPrice - b.Goods[0].BasisPrice);
    // 去重取前lowNum个低价航班
    const priceSet = new Set(sortedFlightList.map(f => f.Goods[0].BasisPrice));
    const uniquePrices = Array.from(priceSet).slice(0, lowNum);
    // 筛选
    __self.lowPriceFlight = lowerflight.filter(f => uniquePrices.includes(f.Goods[0].BasisPrice));
    let minTime = moment(__self.selectflight.ConsumerDate);
    // 时间差值排序 - 多级排序：先按价格，价格相同时按时间差
    let sortedFlights = __self.lowPriceFlight.sort((a: any, b: any) => {
      // 首先比较价格
      let priceDiff = a.Goods[0].BasisPrice - b.Goods[0].BasisPrice;
      if (priceDiff !== 0) {
        return priceDiff; // 价格不同时按价格排序
      }
      // 价格相同时按时间差排序
      let timeA = Math.abs(moment(minTime).diff(moment(a.ConsumerDate)));
      let timeB = Math.abs(moment(minTime).diff(moment(b.ConsumerDate)));
      return timeA - timeB;
    });
    __self.lowPriceFlight = sortedFlights;
    let BenchmarkPrice = lowent.Goods[0].BasisPrice * (1 + (tripLimit.BenchmarkRate || 0) / 100) + (tripLimit.BenchmarkFare || 0);
    // 推荐低价航班是否包含所预定仓位
    const includeLowPrice = __self.lowPriceFlight.some((f: any) => f.Goods[0].BasisPrice === ent.Goods[0].BasisPrice && ent.Goods[0].BasisPrice === berth.BasisPrice);
    __self.dialogVisible = !includeLowPrice && BenchmarkPrice < berth.BasisPrice;
  }

  // bookingLowPriceFlight() {
  //   this.gotoFlightInfo(this.lowPriceFlight, false);
  // }
  // bookingOriginalFlight() {
  //   this.gotoFlightInfo(this.selectflight, false);
  // }

  // TODO:直接预定
  booking(product: any, query: any) {
    const flight = product;
    const detail = product.Goods[0];
    let ProductID = `${flight.SourceId}-${flight.ProductId}-${detail.GoodsId}-${detail.GoodSource}`;
    let ChangeProductID = "";
    if (query.UniqueID) {
      const OldProducts = this.dataShare.changeSource;
      _.forEach(OldProducts, (item: any) => {
        if (item.ConsumerCityName == query.ConsumerCityName) {
          ChangeProductID = `${query.SourceId}-${query.ProductId}-${detail.GoodsId}-${detail.GoodSource}-${item.ProductID}`;
        }
      });
    }
    if (query.ChangeProductID) {
      ChangeProductID = `${query.ChangeProductID},${ChangeProductID}`;
    }
    if (query.VoyageType == VoyageType.RoundVoyage) {
      if (!query.Selected) {
        let PackagePrice = null;
        var extra = _.find(detail.Extras, (p: any) => p.ExtraCode == "flight.VoyageType");
        if (extra) {
          PackagePrice = "true";
        }
        const newQuery = {
          Selected: ProductID,
          SelectId: query.ProductId,
          BookingType: query.BookingType,
          VoyageType: query.VoyageType,
          ApplyArea: query.ApplyArea,
          UniqueID: query.UniqueID,
          ShoppingID: query.ShoppingID,
          ServiceType: ServiceType.FlightService + "",
          Consumers: query.Consumers,
          DepartDate: query.ArriveDate,
          DepartCity: query.ArriveCity,
          ArriveCity: query.DepartCity,
          DepartCityName: query.ArriveCityName,
          ArriveCityName: query.DepartCityName,
          RuleID: query.RuleID,
          FlowID: query.FlowID,
          RuleType: query.RuleType,
          ChangeProductID: ChangeProductID,
          Product: query.Product,

          GoFlightCode: product.ProduceCode,
          GoFlightNo: product.BatchCode,
          GoBerthCode: detail.GoodsCode,
          GoPackagePrice: PackagePrice,
          GoFlightDate: query.DepartDate,
          GoGoodsId: detail.GoodsId,
          BasisPrice: query.BasisPrice,
          HasMultiFlights: query.HasMultiFlights,
        };
        // 更新路由参数新页面
        this.$router
          .replace({ query: newQuery })
          .then(() => {
            window.location.reload();
          })
          .catch(error => {
            console.error(error);
            window.location.reload();
          });
      }
    }
  }

  selectflight: ProductInfo = {};
  selectberth: any = {};
  dialogVisible: boolean = false;
  departurePrice: any = "";
  gotoFlightInfo(product?: any, valiad: boolean = true): void {
    let __self = this;
    __self.selectflight = product;
    __self.selectberth = product.Goods[0];
    if (this.isInternationalRoundTripDeparture) {
      __self.departurePrice = product.Goods[0].BasisPrice;
    }

    if (valiad !== false) {
      //去验证是否为相对最低价
      this.lowPriceFlight = null;
      __self.lowruletime(product, product.Goods[0]);
    } else if (valiad === false) {
      this.dialogVisible = false;
    }
    if (this.lowPriceFlight && this.lowPriceFlight.length > 0) {
      let lowPriceFlight = this.lowPriceFlight[0];
      let suggestGoods = lowPriceFlight.Goods[0];
      let selectedGoods = product.Goods[0];
      let localContrarys = this.dataShare.localContrarys || [];
      _.remove(localContrarys, (o: any) => o.SourceID == selectedGoods.SourceId);
      let BenchmarkPrice = suggestGoods.BasisPrice * (1 + (this.TripLimit.BenchmarkRate || 0) / 100) + (this.TripLimit.BenchmarkFare || 0);
      localContrarys.push({
        SourceID: selectedGoods.SourceId,
        SuggestSourceID: suggestGoods.SourceId,
        SuggestGoodsId: suggestGoods.GoodsId,
        SuggestBasisPrice: BenchmarkPrice,
        ContraryInfo: `航班违背差旅区间管控最低价(¥${BenchmarkPrice}元)`,
      });
      this.dataShare.localContrarys = localContrarys;
    }
    if (__self.dialogVisible) {
      return;
    }
    let Extras = this.transferExtra(product.Extras);
    let stopTime = this.IsStopTime(product.Extras);
    let food = this.foodExtra(product.Extras);
    let airplane = this.airplaneModel(product.Extras);
    let ShareFlight = this.extra(product.Extras, "flight.ShareProduce");
    let Products = JSON.stringify(product.Products);
    let query = this.$route.query;
    // 判断是否包含flight.MultiFlights
    const hasMultiFlights = _.some(product.Extras, (item: any) => item.ExtraCode.trim() === "flight.MultiFlights");

    const pathParameter = {
      ConsumerCityName: product.ConsumerCityName,
      ConsumerZoneName: product.ConsumerZoneName,
      FinishedZoneName: product.FinishedZoneName,
      ConsumerDate: product.ConsumerDate,
      FinishedDate: product.FinishedDate,
      ConsumerDuration: product.ConsumerDuration,
      ProduceName: product.ProduceName,
      ProduceCode: product.ProduceCode,
      BatchCode: product.BatchCode,
      ProductId: product.ProductId, // 航程
      ApplyArea: query.ApplyArea,
      BookingType: query.BookingType,
      Consumers: query.Consumers,
      VoyageType: query.VoyageType,
      Selected: query.Selected,
      SelectId: query.SelectId,
      GoodsId: query.GoGoodsId,
      ShoppingID: this.ShoppingID,
      DepartCity: query.DepartCity,
      ArriveCity: query.ArriveCity,
      DepartCityName: query.DepartCityName,
      ArriveCityName: query.ArriveCityName,
      DepartDate: query.DepartDate,
      ArriveDate: query.ArriveDate,
      RuleType: query.RuleType,
      ProductID: query.Selected, // 去程
      UniqueID: query.UniqueID,
      ChangeProductID: query.ChangeProductID,
      SourceId: product.SourceId, // 航程
      Product: query.Product,
      MustConform: this.MustConform,
      FeatureCodes: this.FeatureCodes,
      Extras: Extras,
      stopTime: stopTime,
      ShareFlight: ShareFlight,
      Food: food,
      Airplane: airplane,
      Products: Products,
      BerthLevel: query.BerthLevel,
      BasisPrice: __self.departurePrice,
      HasMultiFlights: hasMultiFlights ? "true" : "false", // 添加是否包含MultiFlights的信息
    };
    if (this.isInternationalRoundTripDeparture) {
      this.booking(product, pathParameter);
    } else {
      this.$router.push({
        path: "/mall/flight/details",
        query: {
          ...pathParameter,
          BasisPrice: query.BasisPrice,
        },
      });
    }
  }
  getFilters(filters: object, id: string) {
    (this as any).data.Filters = filters;
    (this as any).data.LevelId = id;
    this.isLoading = true;
    this.getListData();
  }
  getSortData(value: any) {
    if (value.code == "AirportDepartTime" && value.mode) {
      (this as any).data.Filters["Price"] = "";
    }
    if (value.code == "Price" && value.mode) {
      (this as any).data.Filters["AirportDepartTime"] = "";
    }
    (this as any).data.Filters[value.code] = value.mode;
    this.isLoading = true;
    this.getListData();
  }
  sortTransit(value: number[] | false) {
    const __self = this;
    if(!value){
       __self.flightLists = __self.oldFlightLists;
       return;
    }
    this.Transit = value;
    this.filterTransit(value)
  }
  setDepartTime(date: string) {
    this.departTime = date;
    this.isLoading = true;
    this.getListData();
  }
  chnageTime(date: string) {
    this.departTime = date;
    this.isLoading = true;
    this.getListData();
  }
  IsContrary(product: any) {
    // const isContrary = _.find(product.Goods, (item: any) => item.Contrarys.length === 0);
    const isContrary = product.Goods[0].Contrarys.length === 0;
    return !isContrary;
  }
  extra(extras: any[], extraCode: string) {
    const Extra = _.find(extras, item => item.ExtraCode == extraCode);
    if (Extra && Extra.ExtraData) {
      return Extra.ExtraData;
    }
    return null;
  }
  foodExtra(Extras: any[]) {
    const Extra = _.find(Extras, item => item.ExtraCode == "flight.FoodName");
    if (Extra) {
      return Extra.ExtraData;
    }
    return "";
  }
  airplaneModel(Extras: any[]) {
    let AirplaneModel = "";
    let result = _.find(Extras, o => o.ExtraCode == "flight.AirplaneModel");
    if (result) {
      AirplaneModel = result.ExtraData;
    }
    return AirplaneModel;
  }
  transferExtra(Extras: any[]) {
    let IsStop = "";
    const result = _.find(Extras, item => item.ExtraCode == "flight.StopProduceName");
    if (result) {
      IsStop = result.ExtraData;
    }
    return IsStop;
  }
  IsStopTime(Extras: any[]) {
    let IsStop = "";
    let result = _.find(Extras, item => item.ExtraCode == "flight.StopProduceTime");
    if (result) {
      IsStop = result.ExtraData;
    }
    return IsStop;
  }
  TripRuleData = "";
  getTripRuleData(TripRule: any) {
    this.TripRuleData = TripRule;
    this.MustConform = TripRule.MustConform;
    this.FeatureCodes = TripRule.FeatureCodes;
  }

  //推荐航班(全天最低价)
  get LowestPrices() {
    let __self = this;
    let minPrices: any = [];
    let LowestLists: any = [];
    let lists = _.clone(__self.flightLists);
    if (lists.length > 0) {
      lists.forEach((o: any) => {
        let result = _.minBy(o.Goods, (n: any) => n.SalesPrice && o.GoodsType == "Young");
        if (result) {
          minPrices.push(result);
        }
      });
      let MinPrice = _.minBy(minPrices, (o: any) => o.SalesPrice);
      LowestLists = _.filter(lists, (o: any) => _.find(o.Goods, m => m.SalesPrice == MinPrice.SalesPrice));
    }
    return LowestLists;
  }

  back() {
    history.back();
  }
  // 跳转国际需求单列表
  goExtendServices() {
    this.$router.push({
      path: "/mall/flight/extendServices",
      query: {
        serviceCode: "flight",
      },
    });
  }
  calculateTimeDifference(startTime: string, endTime: string) {
    const startDate: number = (new Date(startTime) as unknown) as number;
    const endDate: number = (new Date(endTime) as unknown) as number;
    // 计算时间差，单位为秒
    let diffInSeconds = (endDate - startDate) / 1000;
    // 计算天数
    const days = Math.floor(diffInSeconds / (24 * 3600));
    // 剩余的小时数
    const hours = Math.floor((diffInSeconds % (24 * 3600)) / 3600);
    // 剩余的分钟数
    const minutes = Math.floor((diffInSeconds % 3600) / 60);
    // 构建返回结果
    let result = "";
    if (days > 0) result += `${days}d`;
    if (hours > 0) result += `${hours < 10 ? "0" + hours : hours}h`;
    if (minutes > 0) result += `${minutes < 10 ? "0" + minutes : minutes}m`;
    return result;
  }
}
